import React from 'react'
import styled from 'styled-components'

const TitleCont = styled.div`
  margin-bottom: 1rem;
`
const Title = styled.div`
  max-width: calc(100% - 36px);
  margin: 0 0 8px 0;
  font-family: Source Sans Pro;
  font-weight: 900;
  font-size: 21px;
  line-height: 1;
  color: #072b3b;
`

const Subtitle = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  color: #a4a4a4;
`

const popDesc = data => {
  let text =
    data.pop > 0
      ? data.ls > 0
        ? data.ls_telxius > 0
          ? 'PoP & Landing Station On-Net'
          : 'PoP & Landing Station Off-Net'
        : 'PoP'
      : data.ls_telxius > 0
      ? 'Landing Station On-Net'
      : 'Landing Station Off-Net'
  return text
}

const InfoTitle = ({ data, type }) => {
  return (
    <TitleCont>
      <Title>{data.name}</Title>
      <Subtitle>
        {type === 'pop' ? (
          <>
            <p>{data.region + ' - ' + data.country}</p>
            <p>{popDesc(data)}</p>
          </>
        ) : (
          <>
            <p>Submarine Cable</p>
            {data.codename == 'TIKAL-EXT' ?
              (<></>) :
              (
                <p>
                  {data.long.toLocaleString() + ' km'} {' | '} {Math.round(data.long * 0.621371).toLocaleString() + ' miles'}
                </p>
              )
            }
          </>
        )}
      </Subtitle>
    </TitleCont>
  )
}

export default InfoTitle
